import type { AlarmsState } from './reducer';

import type { AppState } from '../AppState';

export const selectNotificationsDomain = (state: AppState): AlarmsState =>
  state.alarms;

export const selectIncidents = (state: AppState) =>
  state.alarms.incidentsWebData;
